import React from 'react'
import { FileText, X, CheckCircle2, AlertTriangle } from 'lucide-react'
import { FileViewer } from '../app/common/fileViewer/FileViewer'
import { ClassificationPanel } from './ClassificationPanel'
import type { DocumentViewerPanelProps } from './types'
import styles from '../../pages/DocumentsPage.module.css'

export const DocumentViewerPanel: React.FC<DocumentViewerPanelProps> = ({
  viewingDocument,
  onClose,
  caseId,
  classification,
  stage,
  onApprove,
  onContinue,
  isApproving,
  classificationsCount,
}) => {
  if (!viewingDocument) {
    return (
      <div className={styles.emptyViewer}>
        <div className={styles.emptyViewerContent}>
          <FileText size={64} className={styles.emptyIcon} />
          <h3>Select a Document</h3>
          <p>Click on a document from the list to view and classify it.</p>
        </div>
      </div>
    )
  }

  const isLowConfidence = classification && classification.confidence < 0.8

  return (
    <div className={styles.viewerLayout}>
      {/* Viewer Header */}
      <div className={styles.viewerHeader}>
        <div className={styles.viewerInfo}>
          <FileText size={18} />
          <span className={styles.viewerFilename}>{viewingDocument.filename}</span>
        </div>
        {classification && (
          <div className={styles.viewerBadges}>
            {(stage === 'approved' || stage === 'approved_with_new') ? (
              <span className={styles.successBadge}>
                <CheckCircle2 size={12} />
                Approved
              </span>
            ) : isLowConfidence ? (
              <span className={styles.warningBadge}>
                <AlertTriangle size={12} />
                Needs Review
              </span>
            ) : (
              <span className={styles.successBadge}>
                <CheckCircle2 size={12} />
                {Math.round(classification.confidence * 100)}%
              </span>
            )}
          </div>
        )}
        <button className={styles.closeBtn} onClick={onClose}>
          <X size={18} />
        </button>
      </div>

      {/* Split: Viewer Left, Details Right */}
      <div className={styles.viewerContent}>
        {/* Document Viewer */}
        <div className={styles.viewerPane}>
          <FileViewer
            key={viewingDocument.docId || viewingDocument.url}
            localFileUrl={viewingDocument.url}
            isModal={false}
            hideHeader={true}
          />
        </div>

        {/* Classification Details */}
        <ClassificationPanel
          classification={classification}
          docId={viewingDocument?.docId}
          caseId={caseId}
          stage={stage}
          onApprove={onApprove}
          onContinue={onContinue}
          isApproving={isApproving}
          classificationsCount={classificationsCount}
        />
      </div>
    </div>
  )
}

